import { render } from "./App.vue?vue&type=template&id=eee11dd8"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=eee11dd8&lang=css"
script.render = render

export default script